import React from "react";
import ItemCard from "./ItemCard";
import { useQuery } from "react-query";
const url = process.env.React_App_Api_url;

const getProducts = async (param) => {
  try {
    const response = await fetch(`${url}/${param}`);
    let resResult = await response.json();
    if (!resResult.length) {
      const backup = await fetch(`${url}/backup`);
      resResult = await backup.json();
    }
    return resResult;
  } catch (error) {
    console.log("REQUEST FAILED AT GET PRODUCT", error);
  }
};
const ItemCatalogue_NoViewAll = (props) => {
  const { title, param, titleImage } = props;

  const {
    data: products,
    isLoading: productLoading,
    isError: productError,
  } = useQuery([`CATALOGUE_${param}`], () => getProducts(param));

  return productLoading || productError ? null : (
    <div
      style={{
        background: "#fff",
        padding: "16px 12px",
        borderRadius: "8px 0px 0px 8px",
      }}
    >
      <div
        className="d-flex align-items-center sec-title"
        style={{ marginBottom: "8px" }}
      >
        <img
          src={titleImage}
          alt="titleImg"
          style={{
            width: "40px",
            minWidth: "40px",
            marginLeft: "4px",
            marginRight: "8px",
          }}
        />
        <h2 style={{ margin: "0" }}>{title}</h2>
      </div>
      <div className="horiz-scroll" style={{ padding: "4px" }}>
        {/* ===========cards=========== */}
        <ItemCard items={products} />
      </div>
    </div>
  );
};

export default ItemCatalogue_NoViewAll;
